import {useHistory, useParams} from "react-router-dom";
import React from "react";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import "./RedirectHintPage.css"; // Your clean, updated CSS

const RedirectHintPage = () => {
    const history = useHistory();
    const { astorId, pageId } = useParams();

    const path = pageId ? `${astorId}/${pageId}` : `${astorId}`;
    const viewerUrl = `${process.env.REACT_APP_VIEWER_URL}${path}`;

    return (
        <div className="redirect-hint-page">
            <main className="main-content">
                <PageTitleSlim title={`Hinweis`} />
                <section className="section-inner">
                    <SectionTitle title={`Neue Url`} />
                    <div className="form-container">
                        <h3>
                            Das ausgewählte Objekt finden Sie ab sofort unter der neuen URL:{" "}
                            <a href={viewerUrl}>viewer.onb.ac.at</a>
                        </h3>
                        <hr />
                        <p>
                            Hier gelangen Sie zu den digitalisierten Objekten der Österreichischen Nationalbibliothek:{" "}
                            <a href="https://onb.digital">onb.digital</a>
                        </p>
                        <button onClick={() => history.push(`/${path}`)} className="button primary hollow">
                            Weiter zum Objekt
                        </button>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default RedirectHintPage;
